module.exports = __webpack_public_path__ + "img/home.38e9c526.svg";